import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import s from './FormTextAreaField.module.scss';
import classNames from 'classnames';

const FormTextAreaField = ({
    placeholder,
    label,
    register,
    type,
    name,
    errors,
    helptext,
    errorMessage = 'This field is required',
    rows = 3,
}) => {
    const [isValid, setIsValid] = useState(null);

    const handleBlur = (e) => {
        const value = e.target.value.trim();
        setIsValid(value !== '');
    };

    const fieldClasses = classNames(s.Field, {
        [s[`Field--Error`]]: errors && errors[name]?.type === 'required',
        [s[`Field--Valid`]]: isValid,
    });

    return (
        <div className={s.Root}>
            <textarea
                id={name}
                type={type}
                name={name}
                rows={rows}
                {...register}
                placeholder={placeholder}
                className={fieldClasses}
                onBlur={handleBlur}
            />
            <label htmlFor={name} className={s.Label}>
                {label}
            </label>
            {helptext && <p className={s.HelpText}>{helptext}</p>}
            {errors && errors[name]?.type === 'required' && !isValid && (
                <span className={s.ErrorMessage}>{errorMessage}</span>
            )}
        </div>
    );
};

FormTextAreaField.propTypes = {
    placeholder: PropTypes.string,
    label: PropTypes.string.isRequired,
    register: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    errors: PropTypes.object,
    helptext: PropTypes.string,
};

export default FormTextAreaField;
